module.exports = "/_next/static/images/c1f907dd4f644e610efed16e7e25fec0-nuapp@3x.png.webp";